import Const from '@/helpers/const'
import { custAxios } from './genericApi'

export default {
  getAllUnlinkedClients (params) {
    return custAxios().get(`${Const.API_CLIENTS}?page=${params.page}&search=${params.search}&sortDirection=${params.sortDirection}&idAccount=${params.idAccount}`)
  },
  updateClientIesAlias (params) {
    return custAxios().patch(`${Const.API_CLIENT}/${params.clientId}`, {
      iesAlias: params.iesAlias
    })
  }
}
